import React from "react";
import * as HelpContent from "../../../../utils/HelpContent";
import { useDispatch } from "react-redux";
import { CHANGE_FREQUENCY, CHANGE_GRID_RANGE_DIRECTION, CHANGE_GRID_RANGE_PERIOD, CHANGE_GRID_RANGE_VALUE } from "../../../../actions/create-bot-type";
import TutorialPopup from "../../../help/TutorialPopup";
import { Button, Form } from "react-bootstrap";
import SliderView from "../SliderView";
import { FrequenciesPro, FrequencyValues, FrequencyValuesPro } from "../../../../Const";


const GridRangeView = (props) => {
  const { newBot,t } = props;
  const frequency = newBot.frequency;
  const dispatch = useDispatch();
  const frequencyChanged = (val) => {
    dispatch({
      type: CHANGE_FREQUENCY,
      payload: val,
    });
  };
  const changeGridDirection = (val) => {
    dispatch({
      type: CHANGE_GRID_RANGE_DIRECTION,
      payload: val,
    });
  };
  const changeRangeValue = (val) => {
    dispatch({
      type: CHANGE_GRID_RANGE_VALUE,
      payload: val,
    });
  };
  const changeRangePeriod = (val) => {
    dispatch({
      type: CHANGE_GRID_RANGE_PERIOD,
      payload: val,
    });
  };
  const formartFrequency = (value) => FrequenciesPro[value];
  return (
    <div>
      <Form.Group>
        <Form.Label>
        Create Grid if the price difference <TutorialPopup content={t("gridDifference")}></TutorialPopup> is 
        </Form.Label>
        <div>
          <Button
            variant={newBot.gridRangeKlineDirection==0?'danger':'outline-secondary'}
            onClick={() => changeGridDirection(0)}
            className="mr-2"
          >
            {t("lesser")}
          </Button>
          <Button
            variant={newBot.gridRangeKlineDirection==1?'success':'outline-secondary'}
            onClick={() => changeGridDirection(1)}
            className="mr-2"
          >
            {t("greater")}
          </Button>
        </div>
       
      </Form.Group>
      <Form.Group>
      than <Form.Control type="number"  className="grid-input" onChange={(e) => changeRangeValue(e.target.value)} value={newBot.gridRangeKlineValue} /> % for the previous last 
      <Form.Control type="number"  className="grid-input" onChange={(e) => changeRangePeriod(e.target.value)} value={newBot.gridRangeKlineNum}/> periods.
      </Form.Group>
      <div style={{ marginTop: 20 }}>
        <SliderView
          title={t("tf")}
          max={4}
          value={FrequencyValuesPro.indexOf(frequency)}
          formatLabel={formartFrequency}
          onChange={(value) => frequencyChanged(FrequencyValuesPro[value])}
          tutorial={<TutorialPopup content={t("trading-freq-help")}  />}
        />
      </div>
    </div>
  );
};

export default GridRangeView;
